export default "__VITE_ASSET__BwgpkGJw__"